import React, { Component } from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";
import classNames from "classnames";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonGroup } from "reactstrap";
import QUERYOPERATOR from "../../_constants/queryOperators";
import "./reportSelection.css";

class WorkPerformedInputs extends Component {
  render() {
    const {
      projectId,
      formData,
      feederLists,
      handleChange_dateQueryType,
      handleChange_dateFrom,
      handleChange_dateTo,
      handleChange_singleDate,
      handleChange_selectMulti,
      wpParamSelectData,
    } = this.props;
    return (
      <div className="card mx-0 mb-2">
        <div className="card-body pb-2">
          <h5 className="mb-3 text-muted">Labor and Equipment</h5>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <div className="custom-control custom-radio date-toggle">
                <input
                  type="radio"
                  name="allDates"
                  id="allDates"
                  checked={formData.dateQueryType === "allDates"}
                  onChange={handleChange_dateQueryType}
                  className="custom-control-input"
                  disabled={!projectId}
                />
                <label htmlFor="allDates" className="custom-control-label">
                  All dates
                </label>
              </div>
            </div>
          </div>
          <div className="form-row form-group mb-2">
            <div className="col-sm-3 my-auto">
              <div className="custom-control custom-radio date-toggle">
                <input
                  type="radio"
                  name="singleDate"
                  id="singleDate"
                  checked={formData.dateQueryType === "singleDate"}
                  onChange={handleChange_dateQueryType}
                  className="custom-control-input"
                  disabled={!projectId}
                />
                <label htmlFor="singleDate" className="custom-control-label">
                  Single Date:
                </label>
              </div>
            </div>
            <div className="col-sm-4">
              <DatePicker
                customInput={<CustomDatePickerInput />}
                name="singleDate"
                id="singleDate"
                selected={formData.singleDate}
                onChange={handleChange_singleDate}
                className="form-control"
                disabled={formData.dateQueryType !== "singleDate" || !projectId}
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <div className="custom-control custom-radio date-toggle">
                <input
                  type="radio"
                  name="dateRange"
                  id="dateRange"
                  checked={formData.dateQueryType === "dateRange"}
                  onChange={handleChange_dateQueryType}
                  className="custom-control-input"
                  disabled={!projectId}
                />
                <label htmlFor="dateRange" className="custom-control-label">
                  Date Range:
                </label>
              </div>
            </div>
            <div className="col-sm-9">
              <div className="row mb-0 ml-0">
                <label htmlFor="dateFrom" className="form-label mx-2 my-auto">
                  From:
                </label>
                <div className="col-4">
                  <DatePicker
                    customInput={
                      <CustomDatePickerInput
                        disabled={formData.dateQueryType !== "dateRange" || !projectId}
                      />
                    }
                    name="dateFrom"
                    id="dateFrom"
                    selected={formData.dateFrom}
                    onChange={handleChange_dateFrom}
                    className="form-control"
                    disabled={formData.dateQueryType !== "dateRange" || !projectId}
                  />
                </div>
                <label htmlFor="dateTo" className="form-label mx-2 my-auto">
                  To:
                </label>
                <div className="col-4">
                  <DatePicker
                    customInput={
                      <CustomDatePickerInput
                        disabled={formData.dateQueryType !== "dateRange" || !projectId}
                      />
                    }
                    name="dateTo"
                    id="dateTo"
                    selected={formData.dateTo}
                    onChange={handleChange_dateTo}
                    className="form-control"
                    disabled={formData.dateQueryType !== "dateRange" || !projectId}
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
          {/*
            Pre-populate the criteria[] as below. This leaves open the possibility
            of updating search criteria selection UI to a more flexible version - in
            which case the criteria will be dynamically populated by the user.
            For now, pre-populate in ReportSelectionModal and pass it in as props.
          */}
          
          {formData.criteria &&
            formData.criteria
            // Filter to only display criteria with IDs 0 (Item), 1 (CCO), or 2 (Pending Issue)
            // This excludes any other criteria types that may exist in the array
            .filter((wpc) => wpc.criteriaId === 0 || wpc.criteriaId === 1 || wpc.criteriaId === 2)  
            .map((wpc, index) => {
              // Options to populate the dropdown boxes with
              const selectData = wpParamSelectData(wpc.criteriaId);
              const sortedOptions = selectData.options.sort((a, b) => 
                a.label.localeCompare(b.label)
              );
              debugger
              return (
                <div
                  key={`wpCriteriaKey_${index}`}
                  className={classNames(
                    {
                      "mb-2": index < formData.criteria.length,
                    },
                    { "mb-0": index === formData.criteria.length - 1 }
                  )}
                >
                  <div className="form-row mx-1 mb-1">
                    <div className="col-sm-3">
                      <span>{wpc.queryByLabel}:</span>
                    </div>
                    <div className="col-sm-9">
                      <Select
                        name="params"
                        id={`wpTypeParams_${wpc.criteriaId}`}
                        className="w-100"
                        styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
                        value={wpc.selectedParams}
                        options={sortedOptions}
                        onChange={handleChange_selectMulti(wpc.criteriaId)}
                        isDisabled={!projectId || !wpc.queryBy}
                        placeholder={selectData.placeholder}
                        isMulti
                        isClearable
                        isSearchable
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          {/* {formData.criteria &&
            formData.criteria.map((wpc, index) => {
              const selectData = wpParamSelectData(wpc.criteriaId);
              return (
                <div className="card mb-2 border-dark">
                  <div className="card-header bg-lightgray d-flex flex-row justify-content-between">
                    <div className="form-row form-group mb-0 w-50">
                      <ButtonGroup className="mr-2" size="sm">
                        <Button
                          name="and"
                          id={`and_${wpc.criteriaId}`}
                          color="secondary"
                          outline
                          onClick={handleClick_and(wpc.criteriaId)}
                          active={wpc.operator === QUERYOPERATOR.AND}
                        >
                          AND
                        </Button>
                        <Button
                          name="or"
                          id={`or_${wpc.criteriaId}`}
                          color="secondary"
                          outline
                          onClick={handleClick_or(wpc.criteriaId)}
                          active={wpc.operator === QUERYOPERATOR.OR}
                          disabled={index === 0}
                        >
                          OR
                        </Button>
                      </ButtonGroup>
                      <div className="col-md-7">
                        <Select
                          name="queryBy"
                          id={`queryBy_${wpc.criteriaId}`}
                          value={wpc.selectedQueryBy}
                          options={wpQueryByOptions}
                          isDisabled={!feederLists || !projectId}
                          placeholder="Search For..."
                          isSearchable={false}
                          onChange={handleChange_select(
                            wpc.criteriaId,
                            "queryBy",
                            "selectedQueryBy"
                          )}
                        />
                      </div>
                    </div>
                    <div className="my-auto">
                      <FontAwesomeIcon icon="times" className="fa-fw text-danger" />
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="form-row form-group mb-0">
                      <div className="col-3">
                        <small>Matching...</small>
                        <Select
                          name="selectParamsBy"
                          id={`selectWpTypeParamsBy_${wpc.criteriaId}`}
                          value={wpc.selectedParamOperator}
                          options={wpParamOperatorOptions}
                          isDisabled={!feederLists || !projectId || !wpc.queryBy}
                          placeholder="Any/All/Ex"
                          isSearchable={false}
                          onChange={handleChange_select(
                            wpc.criteriaId,
                            "selectParamsBy",
                            "selectedSelectParamsBy"
                          )}
                        />
                      </div>
                      <div className="col-9">
                        <small>Of the following...</small>
                        <Select
                          name="params"
                          id={`wpTypeParams_${wpc.criteriaId}`}
                          value={wpc.selectedParams}
                          options={selectData.options}
                          onChange={handleChange_selectMulti(wpc.criteriaId)}
                          isDisabled={!feederLists || !projectId || !wpc.queryBy}
                          placeholder={selectData.placeholder}
                          isMulti
                          isClearable
                          isSearchable
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          <div className="form-row form-group mb-0">
            <div className="col-sm-">
              <button
                type="button"
                name="addAnd"
                id="addAnd"
                className="btn btn-info mr-2"
                onClick={handleClick_addCriteria(QUERYOPERATOR.AND)}
              >
                <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
                AND
              </button>
              <button
                type="button"
                name="addOr"
                id="addOr"
                className="btn btn-warning"
                onClick={handleClick_addCriteria(QUERYOPERATOR.OR)}
              >
                <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
                OR
              </button>
            </div>
          </div> */}

          {/* <div className="form-row form-group">
            <div className="col-sm-2"></div>
            <div className="col-sm-2 my-auto">
              <label htmlFor="itemIds" className="col-form-label">
                Items:
              </label>
            </div>
            <div className="col-sm-8 my-auto">
              <Select
                name="itemIds"
                id="itemIds"
                value={formData.selectedItems}
                options={
                  feederLists &&
                  feederLists.projItemList &&
                  feederLists.projItemList.map((i) => ({
                    value: i.bidItemId,
                    label: i.itemListCaption,
                  }))
                }
                onChange={handleChange_selectMulti("itemIds", "selectedItems")}
                isDisabled={!feederLists || !projectId}
                placeholder="Select Item(s)"
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-2"></div>
            <div className="col-sm-2 my-auto">
              <label htmlFor="ccoIds" className="col-form-label">
                CCOs:
              </label>
            </div>
            <div className="col-sm-8 my-auto">
              <Select
                name="ccoIds"
                id="ccoIds"
                value={formData.selectedCcos}
                options={
                  feederLists &&
                  feederLists.projCcoList &&
                  feederLists.projCcoList.map((c) => ({
                    value: c.ccoId,
                    label: c.ccoListCaption,
                  }))
                }
                onChange={handleChange_selectMulti("ccoIds", "selectedCcos")}
                placeholder="Select CCO(s)"
                isDisabled={!feederLists || !projectId}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-2"></div>
            <div className="col-sm-2 my-auto">
              <label htmlFor="pendingIssueIds" className="col-form-label">
                Pend. Issues:
              </label>
            </div>
            <div className="col-sm-8 my-auto">
              <Select
                name="pendingIssueIds"
                id="pendingIssueIds"
                value={formData.selectedPendingIssues}
                options={
                  feederLists &&
                  feederLists.projPendingIssueList &&
                  feederLists.projPendingIssueList.map((pi) => ({
                    value: pi.pendingIssueId,
                    label: pi.pendingIssueListCaption,
                  }))
                }
                onChange={handleChange_selectMulti(
                  "pendingIssueIds",
                  "selectedPendingIssues"
                )}
                placeholder="Select Pending Issue(s)"
                isDisabled={!feederLists || !projectId}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div> */}
          {/* <hr />
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="laborIds" className="col-form-label">
                Labors:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="laborIds"
                id="laborIds"
                value={formData.selectedLabors}
                options={
                  feederLists &&
                  feederLists.projLaborList &&
                  feederLists.projLaborList.map((l) => ({
                    value: l.laborId,
                    label: l.fullNameTrade,
                  }))
                }
                onChange={handleChange_selectMulti("laborIds", "selectedLabors")}
                placeholder="Select Labor(s)"
                isDisabled={!feederLists || !projectId}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="equipmentIds" className="col-form-label">
                Equipment:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="equipmentIds"
                id="equipmentIds"
                value={formData.selectedEquipment}
                options={
                  feederLists &&
                  feederLists.projEquipList &&
                  feederLists.projEquipList.map((eq) => ({
                    value: eq.equipmentId,
                    label: eq.numberMakeDesc,
                  }))
                }
                onChange={handleChange_selectMulti("equipmentIds", "selectedEquipment")}
                placeholder="Select Equipment"
                isDisabled={!feederLists || !projectId}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="contractorIds" className="col-form-label">
                Contractors:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="contractorIds"
                id="contractorIds"
                value={formData.selectedContractors}
                options={
                  feederLists &&
                  feederLists.projContractorList &&
                  feederLists.projContractorList.map((c) => ({
                    value: c.contractorId,
                    label: c.name,
                  }))
                }
                onChange={handleChange_selectMulti(
                  "contractorIds",
                  "selectedContractors"
                )}
                placeholder="Select Contractor(s)"
                isDisabled={!feederLists || !projectId}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default WorkPerformedInputs;
